import Seo from "./Seo";
import { Reveal } from "./Reveal";

// Shared shell for the legal/info pages (Privacy, Terms, Accessibility).
export default function LegalPage({ testid, path, title, description, updated, intro, sections }) {
  return (
    <article className="pt-32 md:pt-40" data-testid={testid}>
      <Seo title={title} description={description} path={path} />
      <div className="container-x max-w-3xl pb-24">
        <Reveal>
          <p className="eyebrow">Barverse</p>
          <h1 className="mt-4 font-display text-4xl uppercase text-bv-ink sm:text-6xl">
            {title}
          </h1>
          <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-bv-faint">
            Last updated: {updated}
          </p>
          <p className="mt-6 text-lg leading-relaxed text-bv-sub">{intro}</p>
        </Reveal>

        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <Reveal key={s.h}>
              <h2 className="font-display text-xl uppercase text-bv-ink md:text-2xl">{s.h}</h2>
              <div className="mt-3 space-y-3">
                {s.ps.map((p, i) => (
                  <p key={i} className="leading-relaxed text-bv-sub">{p}</p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </article>
  );
}
